const TRACKING_CATEGORY = 'composesdk';
export const trackProductEvent = (action, details, httpClient, isDebugMode = false) => {
    const payload = Object.assign({ action, cat: TRACKING_CATEGORY, eventType: 'product', direct: true }, details);
    if (isDebugMode && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')) {
        console.debug('DEBUG: event payload to send', payload);
        return Promise.resolve();
    }
    return httpClient
        .post('api/activities/', [payload], {
        cache: 'no-store',
        redirect: 'error',
        referrerPolicy: 'same-origin',
        priority: 'low', // Tracking requests can be low priority
    })
        .catch((e) => {
        console.error(`unable to log action=${action}, category=${TRACKING_CATEGORY}`, e);
    });
};
const trackError = (options, httpClient) => {
    const { packageName, packageVersion, component, error } = options;
    let errorMessage = '';
    if (typeof error === 'string') {
        errorMessage = error;
    }
    else if (error instanceof Error) {
        errorMessage = error.message || error.toString();
    }
    return trackProductEvent('sdkError', {
        packageName,
        packageVersion,
        component,
        error: errorMessage,
    }, httpClient);
};
export const trackUiError = (options, httpClient) => trackError(Object.assign(Object.assign({}, options), { packageName: 'sdk-ui' }), httpClient);
export const trackCliError = (options, httpClient) => trackError(Object.assign(Object.assign({}, options), { packageName: 'sdk-cli' }), httpClient);
//# sourceMappingURL=tracking.js.map